import { useContext } from 'react';

import { StoreContext } from './StoreContext';

// 创建上下文
export const useStoreContext = () => useContext(StoreContext);
